import React from "react";
import { CgClose } from "react-icons/cg";
import ApplicationReadyForAssessmentForm from "./ApplicationReadyForAssessmentForm";

const index = ({ showPopup, modalRef, closePopup, handleSubmit, loading, id }) => {
  return (
    <div className="Confirm_popup">
      <div className={`modal custom-popup-overlay ${showPopup ? "show" : ""}`}>
        <div
          className="modal-content custom-popup-add"
          ref={modalRef}>
          <div className="d-flex flex-row-reverse">
            <div>
              <span
                className="cursor-pointer"
                onClick={closePopup}>
                <CgClose
                  style={{
                    color: "#D1D5DB",
                    height: "30px",
                    width: "30px",
                  }}
                />
              </span>
            </div>
          </div>

          <div>
            <ApplicationReadyForAssessmentForm
              closePopup={closePopup}
              handleSubmit={handleSubmit}
              loading={loading}
              id={id}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default index;
